'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var classNames = require('classnames');
var common = require('@andes/common');
var context = require('@andes/context');
var _extends = require('@babel/runtime/helpers/extends');
var FeedbackCaution24 = require('@andes/icons/FeedbackCaution24');
var FeedbackInfo24 = require('@andes/icons/FeedbackInfo24');
var FeedbackNegative24 = require('@andes/icons/FeedbackNegative24');
var FeedbackPositive24 = require('@andes/icons/FeedbackPositive24');
var includes = require('@andes/common/build/utils/includes');
var warning = require('@andes/common/build/utils/warning');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var FeedbackCaution24__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackCaution24);
var FeedbackInfo24__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackInfo24);
var FeedbackNegative24__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackNegative24);
var FeedbackPositive24__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackPositive24);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
const namespace = 'andes-badge';
const PILL_TYPE_ICON = 'icon';
const PILL_TYPE_TEXT = 'text';
const ROUNDED_CORNERS_VALUES = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
const WARNING_NOTIFICATION = "<Notification> component will be deprecated in a future major version.\nPlease use <Pill> with `contentType='icon'` instead.";
const computeColorProps = _ref => {
  let {
    type,
    color
  } = _ref;
  if (color) return color;
  switch (type) {
    case 'neutral':
      return 'accent';
    case 'generic':
      return 'gray';
    case 'success':
      return 'green';
    case 'warning':
      return 'orange';
    case 'error':
      return 'red';
    default:
      return 'accent';
  }
};
var computeColorProps$1 = computeColorProps;
const _excluded$2 = ["aria-label", "className", "color", "id", "srLabel", "type"];
const Dot = /*#__PURE__*/function () {
  const Dot = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        'aria-label': _willDeprecate$ariaLabel,
        className,
        color,
        id,
        srLabel,
        type: _willDeprecate$type
      } = props,
      otherProps = _objectWithoutProperties__default["default"](props, _excluded$2);
    const componentId = context.useId(id);
    const computedColor = computeColorProps$1({
      type: _willDeprecate$type,
      color
    });
    const classes = classNames__default["default"](namespace, className, "".concat(namespace, "--dot"), "".concat(namespace, "--").concat(computedColor));
    const sharedProps = _objectSpread__default["default"]({
      className: classes,
      id: componentId,
      ref
    }, otherProps);
    const ariaLabel = srLabel || _willDeprecate$ariaLabel;
    return /*#__PURE__*/React__default["default"].createElement("div", sharedProps, ariaLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, ariaLabel));
  });
  Dot.displayName = 'Dot';
  return Dot;
}();
var Dot$1 = Dot;
const getSign = color => {
  const commonProps = {
    className: "".concat(namespace, "__icon-inner"),
    color: 'white'
  };
  const colors = {
    accent: /*#__PURE__*/React__default["default"].createElement(FeedbackInfo24__default["default"], _extends__default["default"]({}, commonProps, {
      key: "badge-info"
    })),
    green: /*#__PURE__*/React__default["default"].createElement(FeedbackPositive24__default["default"], _extends__default["default"]({}, commonProps, {
      key: "badge-success"
    })),
    orange: /*#__PURE__*/React__default["default"].createElement(FeedbackCaution24__default["default"], _extends__default["default"]({}, commonProps, {
      key: "badge-warning"
    })),
    red: /*#__PURE__*/React__default["default"].createElement(FeedbackNegative24__default["default"], _extends__default["default"]({}, commonProps, {
      key: "badge-error"
    }))
  };
  return colors[color];
};
const PillIcon = _ref => {
  let {
    color = 'accent'
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"]("div", {
    "aria-hidden": "true",
    className: "".concat(namespace, "__icon")
  }, void 0, getSign(color));
};
var NotificationIcon = PillIcon;
const computeBorder = _ref => {
  let {
    border,
    roundedCorners
  } = _ref;
  if (border === 'corner') {
    return ['top-right', 'bottom-left'];
  }
  if (border === 'rounded') {
    return ['bottom-left'];
  }
  return roundedCorners || ROUNDED_CORNERS_VALUES;
};
var computeBorder$1 = computeBorder;
const _excluded$1 = ["aria-label", "border", "children", "className", "color", "contentType", "hierarchy", "id", "roundedCorners", "secondaryColor", "size", "srLabel", "type"];
const Pill = /*#__PURE__*/function () {
  const Pill = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        'aria-label': _willDeprecate$ariaLabel,
        border: _willDeprecate$border,
        children,
        className,
        color,
        contentType = 'text',
        hierarchy = 'loud',
        id,
        roundedCorners = ROUNDED_CORNERS_VALUES,
        secondaryColor,
        size = 'large',
        srLabel,
        type: _willDeprecate$type
      } = props,
      otherProps = _objectWithoutProperties__default["default"](props, _excluded$1);
    const componentId = context.useId(id);
    const computedColor = computeColorProps$1({
      type: _willDeprecate$type,
      color
    });
    const computedBorder = computeBorder$1({
      border: _willDeprecate$border,
      roundedCorners
    });
    const isText = contentType === PILL_TYPE_TEXT;
    const isIcon = contentType === PILL_TYPE_ICON;
    const classes = classNames__default["default"](namespace, "".concat(namespace, "--pill"), "".concat(namespace, "--").concat(computedColor), className, {
      ["".concat(namespace, "--pill-icon")]: isIcon,
      ["".concat(namespace, "--").concat(size)]: size,
      ["".concat(namespace, "--").concat(computedColor, "--quiet")]: !secondaryColor && hierarchy === 'quiet' && isText,
      ["".concat(namespace, "--rounded-top-left")]: includes__default["default"](computedBorder, 'top-left') && isText,
      ["".concat(namespace, "--rounded-top-right")]: includes__default["default"](computedBorder, 'top-right') && isText,
      ["".concat(namespace, "--rounded-bottom-left")]: includes__default["default"](computedBorder, 'bottom-left') && isText,
      ["".concat(namespace, "--rounded-bottom-right")]: includes__default["default"](computedBorder, 'bottom-right') && isText
    });
    const sharedProps = _objectSpread__default["default"]({
      className: classes,
      id: componentId,
      ref
    }, otherProps);
    const computedSrLabel = srLabel || _willDeprecate$ariaLabel;
    if (isIcon) {
      return /*#__PURE__*/React__default["default"].createElement("div", sharedProps, computedSrLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, computedSrLabel), /*#__PURE__*/_jsx__default["default"](NotificationIcon, {
        color: computedColor
      }));
    }
    return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({}, sharedProps, {
      style: {
        backgroundColor: secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.background
      }
    }), computedSrLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, computedSrLabel), children && /*#__PURE__*/_jsx__default["default"]("p", {
      "aria-hidden": !!computedSrLabel || undefined,
      className: "".concat(namespace, "__content"),
      style: {
        color: secondaryColor === null || secondaryColor === void 0 ? void 0 : secondaryColor.text
      }
    }, void 0, children));
  });
  Pill.displayName = 'Pill';
  return Pill;
}();
var Pill$1 = Pill;
const _excluded = ["aria-label", "type", "className", "size"];
const Notification = /*#__PURE__*/function () {
  const Notification = _ref => {
    let {
        'aria-label': ariaLabel,
        type = 'neutral',
        className,
        size = 'large'
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);
    React__default["default"].useEffect(() => {
      warning__default["default"](false, WARNING_NOTIFICATION);
    }, []);
    const computedColor = computeColorProps$1({
      type
    });
    const classes = classNames__default["default"](namespace, "".concat(namespace, "--notification"), "".concat(namespace, "--").concat(computedColor), className, {
      'andes-badge--small': size === 'small'
    });
    const sharedProps = _objectSpread__default["default"]({
      className: classes
    }, props);
    return /*#__PURE__*/React__default["default"].createElement("div", sharedProps, ariaLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, ariaLabel), /*#__PURE__*/_jsx__default["default"](NotificationIcon, {
      color: computedColor === 'gray' ? 'accent' : computedColor
    }));
  };
  Notification.displayName = 'Notification';
  return Notification;
}();
var Notification$1 = Notification;
exports.Dot = Dot$1;
exports.Notification = Notification$1;
exports.Pill = Pill$1;
